/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { FaSearch, FaSpotify } from "react-icons/fa";
import BackButton from "../../components/backButton";
import Button from "../../components/button";
import H1 from "../../components/h1";
import P from "../../components/p";
import getColours from "../../helpers/getColours";
import useDomainConfigAuth from "../../api/sanity/queries/getSiteConfigWithDomain";

import Spacer from "../../components/spacer";
import { getUserMeta } from "../../api/queries";
import AppState from "../../store/appstate";
import SmallButton from "../../components/smallButton";
import ButtonLink from "../../components/buttonLink";
import Select from "../../components/select";
import AuthPrimaryButton from "../../components/authPrimaryButton";

function AddAccount3() {
	const { t } = useTranslation("onboarding");
	const history = useHistory();
	const userMeta = getUserMeta();
	const addAccount = AppState.useState((s) => s.addAccount);
	const [pending, setPending] = useState(false);
	const { data: domainConfig } = useDomainConfigAuth();
	const { highlightColour } = getColours(domainConfig);
	const isTunecore = domainConfig?.display_name === "TuneCore";

	let title = t("onboarding:spotify-title1");
	let desc = t("onboarding:spotify-desc1");
	switch (userMeta?.data?.role) {
		case "Label":
		case "Manager":
			title = t("onboarding:spotify-title2");
			desc = t("onboarding:spotify-desc2");
			break;
		default:
			break;
	}

	const [apiToken, setAPIToken] = useState(null);

	const getSpotifyAPIToken = async () => {
		const apiUrl = AppState.getRawState()?.apiUrl;

		const response = await fetch(`${apiUrl}/spotify-token`);
		const responseData = await response.json();
		return responseData.access_token;
	};

	useEffect(() => {
		async function go() {
			setAPIToken(await getSpotifyAPIToken());
		}
		go();
	}, []);

	const getOptions = (query) =>
		new Promise((resolve, reject) => {
			if (!query) {
				resolve([]);
				return;
			}
			fetch(
				`https://api.spotify.com/v1/search?q=${query}&type=artist&market=GB&limit=50`,
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${apiToken}`,
					},
				}
			)
				.then((response) => response.json())
				.then(({ artists }) => {
					resolve(
						artists.items.map((artist) => ({
							value: JSON.stringify(artist),
							name: artist.name,
							photo:
								artist.images && artist.images.length > 0
									? artist.images[0].url
									: null,
						}))
					);
				})
				.catch(reject);
		});

	return (
		<div className='container mx-auto'>
			<div className='flex flex-col items-center justify-center p-4 text-center text-white min-h-screen-minus-footer'>
				<p className='text-6xl text-white'>
					<FaSpotify />
				</p>
				<Spacer />
				{!addAccount.spotify && (
					<>
						<h1 className='text-6xl'>{title}</h1>
						<Spacer />
						<P>{desc}</P>
						<Spacer />
						<div className='relative flex flex-col items-center justify-center w-full'>
							<div className='w-full lg:w-1/3'>
								<div className='flex flex-row items-start justify-center w-full text-old-sentric-dark-gray'>
									<Select
										customLabel={t(
											"onboarding:spotify-profile-search-placeholder"
										)}
										className={`${
											isTunecore
												? "tunecore-select tunecore-input-hover"
												: "custom-select no-dropdown"
										} text-old-sentric-dark-gray`}
										debounce
										onChange={(artist) => {
											AppState.update((s) => {
												s.addAccount.spotify = artist;
											});
										}}
										getOptions={getOptions}
										placeholder={t(
											"onboarding:spotify-profile-search-placeholder"
										)}
										authSearch
										search
									/>
								</div>
							</div>
						</div>
					</>
				)}
				{!!addAccount.spotify && (
					<>
						<h1 className='text-6xl'>
							{t("onboarding:selected-spotify-profile")}
						</h1>
						<Spacer />
						<div className='flex flex-col items-center p-4 px-6 bg-white rounded-lg shadow-lg bg-opacity-80 text-old-sentric-dark-gray'>
							{JSON.parse(addAccount.spotify).images &&
								JSON.parse(addAccount.spotify).images.length > 0 && (
									<img
										className='object-cover w-40 h-40 mb-4 rounded-full shadow-2xl'
										alt={JSON.parse(addAccount.spotify).name}
										src={JSON.parse(addAccount.spotify).images[0].url}
									/>
								)}
							{(!JSON.parse(addAccount.spotify).images ||
								JSON.parse(addAccount.spotify).images.length === 0) && (
								<div className='w-20 h-20 mb-4 bg-gray-300 rounded-lg' />
							)}
							<p className='mb-4 font-bold'>
								{JSON.parse(addAccount.spotify).name}
							</p>
							<SmallButton
								onClick={() => {
									AppState.update((s) => {
										s.addAccount.spotify = null;
									});
								}}
							>
								{t("common:remove")}
							</SmallButton>
						</div>
					</>
				)}
				<Spacer />

				<div className='flex flex-row w-full lg:w-1/3 justify-evenly'>
					<BackButton onClick={() => history.push("/add-account-1")}>
						{t("onboarding:back-button")}
					</BackButton>
					<AuthPrimaryButton
						disabled={addAccount.spotify === null}
						pending={pending}
						onClick={() => history.push("/add-account-4") && setPending(true)}
						arrow
					>
						{t("onboarding:next-step-button")}
					</AuthPrimaryButton>
				</div>
				<Spacer />
				<ButtonLink onClick={() => history.push("/add-account-4")}>
					{t("onboarding:skip-step-button")}
				</ButtonLink>
			</div>
		</div>
	);
}

export default AddAccount3;
